import { useState } from 'react';
import {
  BoPhan,
  ChiPhiKhongHopLeData as ChiPhi,
  DoiTuong,
  DotThanhToan,
  Group,
  HopDong,
  KheUoc,
  KhoHang,
  KhuVuc,
  Lo,
  type NhanVien,
  Phi,
  TaiKhoan,
  VatTu,
  ViTri,
  VuViec
} from '@/types/schemas';

export interface SearchDialogState {
  // Customer/Supplier related
  nhanVien: NhanVien | null;
  khachHang: DoiTuong | null;
  nhomKhachHang1: Group | null;
  nhomKhachHang2: Group | null;
  nhomKhachHang3: Group | null;
  khuVuc: KhuVuc | null;

  // Other tab fields
  giaoDich: BanHangRecord | null;
}

export interface SearchDialogActions {
  // Customer/Supplier related
  setNhanVien: (nhanVien: NhanVien) => void;
  setKhachHang: (khachHang: DoiTuong) => void;
  setNhomKhachHang1: (nhomKhachHang1: Group) => void;
  setNhomKhachHang2: (nhomKhachHang2: Group) => void;
  setNhomKhachHang3: (nhomKhachHang3: Group) => void;
  setKhuVuc: (khuVuc: KhuVuc) => void;

  // Other tab fields
  setGiaoDich: (giaoDich: BanHangRecord) => void;

  // Utility actions
  resetState: () => void;
  updateState: (updates: Partial<SearchDialogState>) => void;
}

export interface UseSearchFieldStatesReturn {
  state: SearchDialogState;
  actions: SearchDialogActions;
}

const initialState: SearchDialogState = {
  // Customer/Supplier related
  nhanVien: null,
  khachHang: null,
  nhomKhachHang1: null,
  nhomKhachHang2: null,
  nhomKhachHang3: null,
  khuVuc: null,

  // Other tab fields
  giaoDich: null
};

export function useSearchFieldStates(initialValues?: Partial<SearchDialogState>): UseSearchFieldStatesReturn {
  const [state, setState] = useState<SearchDialogState>({
    ...initialState,
    ...initialValues
  });

  const actions: SearchDialogActions = {
    // Customer/Supplier related
    setNhanVien: (nhanVien: NhanVien) => {
      setState(prev => ({ ...prev, nhanVien }));
    },

    setKhachHang: (khachHang: DoiTuong) => {
      setState(prev => ({ ...prev, khachHang }));
    },

    setNhomKhachHang1: (nhomKhachHang1: Group) => {
      setState(prev => ({ ...prev, nhomKhachHang1 }));
    },

    setNhomKhachHang2: (nhomKhachHang2: Group) => {
      setState(prev => ({ ...prev, nhomKhachHang2 }));
    },

    setNhomKhachHang3: (nhomKhachHang3: Group) => {
      setState(prev => ({ ...prev, nhomKhachHang3 }));
    },

    setKhuVuc: (khuVuc: KhuVuc) => {
      setState(prev => ({ ...prev, khuVuc }));
    },

    // Other tab fields
    setGiaoDich: (giaoDich: BanHangRecord) => {
      setState(prev => ({ ...prev, giaoDich }));
    },

    // Utility actions
    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<SearchDialogState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
